import { render, staticRenderFns } from "./smartauthen.vue?vue&type=template&id=532c1ae6&scoped=true&"
import script from "./smartauthen.vue?vue&type=script&lang=js&"
export * from "./smartauthen.vue?vue&type=script&lang=js&"
import style0 from "./smartauthen.vue?vue&type=style&index=0&id=532c1ae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532c1ae6",
  null
  
)

export default component.exports